<template>
    <div class="snackbar">
        <button class="snackbar__close" type="button" @click="emitEvent({ name: 'close' })">
            <common-icon name="close-black" size="tiny"></common-icon>
        </button>
        <div v-if="showSnackContent" class="snackbar__content">
            <div class="snackbar__content--title">
                {{ title }}
            </div>

            <div v-if="buttonLabel" class="snackbar__content--action">
                <common-button
                    type="primary"
                    :label="buttonLabel"
                    size="micro"
                    @click="emitEvent({ name: 'snackbar-action' })"
                ></common-button>
            </div>
        </div>
        <slot name="expand"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            title: { type: String, default: '' },
            buttonLabel: { type: String, default: undefined },
            showSnackContent: { type: Boolean, default: true },
        },
    }
</script>

<style lang="scss">
    @import 'styles/components/snackbar/snackbar.scss';
</style>
